// Music card game data with rankings
export const MUSIC_CARDS = [
  { id: 1, name: "The Beatles", rank: 1 ,
    image: "/images/music/music_1.jpg"
  },
  { id: 2, name: "Michael Jackson", rank: 2 ,
    image: "/images/music/music_2.jpg"
  },
  { id: 3, name: "Elvis Presley", rank: 3 ,
    image: "/images/music/music_3.jpg"
  },
  { id: 4, name: "Elton John", rank: 4 ,
    image: "/images/music/music_4.jpg"
  },
  { id: 5, name: "Queen", rank: 5 ,
    image: "/images/music/music_5.jpg"
  },
  { id: 6, name: "Madonna", rank: 6 ,
    image: "/images/music/music_6.jpg"
  },
  { id: 7, name: "Led Zeppelin", rank: 7 ,
    image: "/images/music/music_7.jpg"
  },
  { id: 8, name: "Rihanna", rank: 8 ,
    image: "/images/music/music_8.jpg"
  },
  { id: 9, name: "Pink Floyd", rank: 9 ,
    image: "/images/music/music_9.jpg"
  },
  { id: 10, name: "Eminem", rank: 10 ,
    image: "/images/music/music_10.jpg"
  },
  { id: 11, name: "Mariah Carey", rank: 11 ,
    image: "/images/music/music_11.jpg"
  },
  { id: 12, name: "Whitney Houston", rank: 12 ,
    image: "/images/music/music_12.jpg"
  },
  { id: 13, name: "Taylor Swift", rank: 13 ,
    image: "/images/music/music_13.jpg"
  },
  { id: 14, name: "Beyonce", rank: 14 ,
    image: "/images/music/music_14.jpg"
  },
  { id: 15, name: "Ed Sheeran", rank: 15 ,
    image: "/images/music/music_15.jpg"
  },
  { id: 16, name: "AC/DC", rank: 16 ,
    image: "/images/music/music_16.jpg"
  },
  { id: 17, name: "Eagles", rank: 17 ,
    image: "/images/music/music_17.jpg"
  },
  { id: 18, name: "Celine Dion", rank: 18 ,
    image: "/images/music/music_18.jpg"
  },
  { id: 19, name: "The Rolling Stones", rank: 19 ,
    image: "/images/music/music_19.jpg"
  },
  { id: 20, name: "Drake", rank: 20 ,
    image: "/images/music/music_20.jpg"
  },
  { id: 21, name: "Garth Brooks", rank: 21 ,
    image: "/images/music/music_21.jpg"
  },
  { id: 22, name: "Kanye West", rank: 22 ,
    image: "/images/music/music_22.jpg"
  },
  { id: 23, name: "Coldplay", rank: 23 ,
    image: "/images/music/music_23.jpg"
  },
  { id: 24, name: "Billy Joel", rank: 24 ,
    image: "/images/music/music_24.jpg"
  },
  { id: 25, name: "Katy Perry", rank: 25 ,
    image: "/images/music/music_25.jpg"
  },
  { id: 26, name: "Justin Bieber", rank: 26 ,
    image: "/images/music/music_26.jpg"
  },
  { id: 27, name: "Bruno Mars", rank: 27 ,
    image: "/images/music/music_27.jpg"
  },
  { id: 28, name: "Britney Spears", rank: 28 ,
    image: "/images/music/music_28.jpg"
  },
  { id: 29, name: "Metallica", rank: 29 ,
    image: "/images/music/music_29.jpg"
  },
  { id: 30, name: "Aerosmith", rank: 30 ,
    image: "/images/music/music_30.jpg"
  }
];
